import {emotionStyled} from '@packages/utilities/styled';
import {lineClampVar} from '../../hooks';

const reset = {
  margin: 0,
  padding: 0,
  lineHeight: '1.4',
};

export const TextView = emotionStyled('span')(
  {
    ...reset,
    // @ts-expect-error - Property.LineClamp is incorrectly typed. This is a `var()` string, which is syntactically correct.
    lineClamp: lineClampVar.get,
  },
  {
    componentName: 'Text',
    variants: {
      font: {
        // System typography styles
        title: {
          fontFamily: '$title',
          fontSize: '$title',
          fontWeight: '$title',
          lineHeight: '$title',
        },
        heading: {
          fontFamily: '$heading',
          fontSize: '$heading',
          fontWeight: '$heading',
          lineHeight: '$heading',
        },
        body: {
          fontFamily: '$body',
          fontSize: '$body',
          fontWeight: '$body',
          lineHeight: '$body',
        },
        helpText: {
          fontFamily: '$helpText',
          fontSize: '$helpText',
          fontWeight: '$helpText',
          lineHeight: '$helpText',
        },
        code: {
          fontFamily: '$code',
          fontSize: '$code',
          fontWeight: '$code',
          lineHeight: '$code',
        },
        // Branded typography styles
        brandedDisplay1: {
          fontFamily: '$brandedDisplay1',
          fontSize: '$brandedDisplay1',
          fontWeight: '$brandedDisplay1',
          lineHeight: '$brandedDisplay1',
          fontFeatureSettings: '"rlig" 0',
        },
        brandedDisplay2: {
          fontFamily: '$brandedDisplay2',
          fontSize: '$brandedDisplay2',
          fontWeight: '$brandedDisplay2',
          lineHeight: '$brandedDisplay2',
          fontFeatureSettings: '"rlig" 0',
        },
        brandedDisplay3: {
          fontFamily: '$brandedDisplay3',
          fontSize: '$brandedDisplay3',
          fontWeight: '$brandedDisplay3',
          lineHeight: '$brandedDisplay3',
          fontFeatureSettings: '"rlig" 0',
        },
        brandedDisplay4: {
          fontFamily: '$brandedDisplay4',
          fontSize: '$brandedDisplay4',
          fontWeight: '$brandedDisplay4',
          lineHeight: '$brandedDisplay4',
          fontFeatureSettings: '"rlig" 0',
        },
        brandedDisplay5: {
          fontFamily: '$brandedDisplay5',
          fontSize: '$brandedDisplay5',
          fontWeight: '$brandedDisplay5',
          lineHeight: '$brandedDisplay5',
          fontFeatureSettings: '"rlig" 0',
        },
        brandedDisplay6: {
          fontFamily: '$brandedDisplay6',
          fontSize: '$brandedDisplay6',
          fontWeight: '$brandedDisplay6',
          lineHeight: '$brandedDisplay6',
          fontFeatureSettings: '"rlig" 0',
        },
        brandedDisplaySubtitle: {
          fontFamily: '$brandedDisplaySubtitle',
          fontSize: '$brandedDisplaySubtitle',
          fontWeight: '$brandedDisplaySubtitle',
          lineHeight: '$brandedDisplaySubtitle',
        },
        brandedHeading: {
          fontFamily: '$brandedHeading',
          fontSize: '$brandedHeading',
          fontWeight: '$brandedHeading',
          lineHeight: '$brandedHeading',
        },
        brandedBody: {
          fontFamily: '$brandedBody',
          fontSize: '$brandedBody',
          fontWeight: '$brandedBody',
          lineHeight: '$brandedBody',
        },
        brandedHelpText: {
          fontFamily: '$brandedHelpText',
          fontSize: '$brandedHelpText',
          fontWeight: '$brandedHelpText',
          lineHeight: '$brandedHelpText',
        },
      },
      weight: {
        normal: {
          fontWeight: '$normal',
        },
        semibold: {
          fontWeight: '$semibold',
        },
      },
      colorVariant: {
        inherit: {
          color: 'currentColor',
        },
        /**
         * Base colors
         */
        primary: {
          color: '$textPrimary',
        },
        secondary: {
          color: '$textSecondary',
        },
        dimmed: {
          color: '$textDimmed',
        },
        inverse: {
          color: '$textInverse',
        },
        /**
         * Stateless colors
         */
        blue: {
          color: '$blueText',
        },
        green: {
          color: '$greenText',
        },
        orange: {
          color: '$orangeText',
        },
        pink: {
          color: '$pinkText',
        },
        purple: {
          color: '$purpleText',
        },
        yellow: {
          color: '$yellowText',
        },
        /**
         * Stateful colors
         */
        danger: {
          color: '$redText',
        },
        success: {
          color: '$greenText',
        },
        warning: {
          color: '$yellowText',
        },
      },
      // used to turn WF-Visual Sans into a single story font
      isSingleStory: {
        true: {
          fontFeatureSettings: '"rlig" 0',
        },
      },
      truncation: {
        truncated: {
          width: '100%',
        },
        'truncated-inline': {
          display: 'inline-block',
          width: '100%',
        },
      },
    },
    defaultVariants: {
      font: 'body',
      weight: 'regular',
      colorVariant: 'inherit',
    },
  }
);
